import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import MetaTags from "react-meta-tags";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { connect } from "react-redux";
import { Section, Title, Article, Prop, list } from "./animationList";
import ReactLoading from "react-loading";
import {
  getDiscountPrice,
  getDiscountPriceVariation,
  getFinalPriceVariation,
} from "../../helpers/product";

import {
  addToCart,
  adjustCartForCheckOut,
  decrementQty,
  removeFromCart,
  cartItemStock,
  removeAllFromCart,
} from "../../redux/actions/cartActions";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import { BorderRight } from "@mui/icons-material";
import { size } from "lodash";

const Cart = ({
  location,
  cartItems,
  currency,
  decrementQty,
  addToCart,
  adjustCartForCheckOut,
  removeFromCart,
  removeAllFromCart,
  userData,
  products,
}) => {
  const [inCaricamentoCheckOut, setinCaricamentoCheckOut] = useState(false);

  const [quantityCount] = useState(1);
  const { addToast } = useToasts();
  const { pathname } = location;
  let cartTotalPrice = 0;
  const [tot, setTot] = useState(0);
  const [totPortoFranco, setTotPortoFranco] = useState(0);
  var strings = require("../../translations/italian.json");
  var informazioni = global.informazioni;
  const isBetaRicambi = global.aziendaID === 4 ? true : false;
  const isLoggedUser =
    userData?.user?.user &&
      (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge)
      ? true
      : false;
  const clienteVisualizzaPrezzi =
    isLoggedUser && userData?.user?.user?.showPrice
      ? userData?.user?.user?.showPrice == 1
      : false;
  useEffect(() => {
    var totale = 0;
    if (cartItems && cartItems.length > 0) {
      cartItems.forEach((single) => {
        var finalProductPrice = 0;
        if (!single?.variation || single.variation?.length == 0) {
          finalProductPrice = single.price?.toFixed(2);
        } else {
          const discountedPrice = getDiscountPrice(
            single.price,
            single.discount,
            single.pricesco
          );
          finalProductPrice = getFinalPriceVariation(
            single,
            single.selectedProductColor,
            single.selectedProductSize
          ).toFixed(2);
          const finalDiscountedPrice = (
            discountedPrice * currency.currencyRate
          ).toFixed(2);
        }

        totale += finalProductPrice * single.quantity;
      });
      setTot(totale);
      setTotPortoFranco(390.0 - totale);
    }
  }, [cartItems]);
  const getCartItems = () => {
    return (
      <div className="row">
        <div className="col-12">
          <div className="table-content table-responsive cart-table-content">
            <table>
              <thead>
                <tr>
                  <th>Immagine</th>
                  <th>Nome Prodotto</th>
                  {(isBetaRicambi ? clienteVisualizzaPrezzi : true) && (
                    <th>Prezzo</th>
                  )}
                  <th>Quantità</th>
                  {(isBetaRicambi ? clienteVisualizzaPrezzi : true) && (
                    <th>Subtotale</th>
                  )}
                  <th>Azione</th>
                </tr>
              </thead>
              <tbody>
                {cartItems?.map((cartItem, key) => {
                  const discountedPrice = getDiscountPrice(
                    cartItem.price,
                    cartItem.discount,
                    cartItem.pricesco,
                    cartItem
                  );

                  const finalProductPrice = getFinalPriceVariation(
                    cartItem,
                    cartItem.selectedProductColor,
                    cartItem.selectedProductSize,
                    cartItem
                  ).toFixed(2);
                  const finalDiscountedPrice = (
                    discountedPrice * currency.currencyRate
                  ).toFixed(2);

                  discountedPrice != null && global.aziendaID != 1
                    ? (cartTotalPrice +=
                      finalDiscountedPrice * cartItem.quantity)
                    : (cartTotalPrice += finalProductPrice * cartItem.quantity);
                  return (
                    <tr key={key}>
                      <td className="product-thumbnail">
                        {global.aziendaID == 3 ?
                          <span>
                            <img
                              className="img-fluid"
                              src={global.baseUrlImage + cartItem.image[0]}
                              alt=""
                              onError={() => {
                                var elms = document.querySelectorAll(
                                  "[id='" + "image-prod-" + cartItem.id + "']"
                                );
                                for (var i = 0; i < elms.length; i++) {
                                  elms[i].src = global.placeholderImage;
                                  elms[i].style.objectFit = "contain";
                                }
                              }}
                            />
                          </span> :
                          <Link
                            to={
                              process.env.PUBLIC_URL + "/product/" + cartItem.id
                            }
                            disable={global.aziendaID === 3}
                          >
                            <img
                              className="img-fluid"
                              id={"image-prod-" + cartItem.id}

                              src={global.baseUrlImage + cartItem.image[0]}
                              alt=""
                              onError={() => {
                                var elms = document.querySelectorAll(
                                  "[id='" + "image-prod-" + cartItem.id + "']"
                                );
                                for (var i = 0; i < elms.length; i++) {
                                  elms[i].src = global.placeholderImage;
                                  elms[i].style.objectFit = "contain";
                                }
                              }}
                            />
                          </Link>}
                      </td>

                      <td className="product-name">
                        {global.aziendaID == 3 ?
                          <span>
                            {cartItem.sku}
                            <br />
                            {cartItem.name}
                          </span> :
                          <Link
                            to={
                              process.env.PUBLIC_URL + "/product/" + cartItem.id
                            }
                          >
                            {cartItem.sku}
                            <br />
                            {cartItem.name}
                          </Link>}
                        {cartItem.selectedProductColor &&
                          cartItem.selectedProductSize ? (
                          <div className="cart-item-variation">
                            <span>Color: {cartItem.selectedProductColor}</span>
                            <span>Size: {cartItem.selectedProductSize}</span>
                            {global.aziendaID === 3 && cartItem.IDArtSta > 0 && (
                              <span>
                                Grafica: {products.find((p) => p.id == cartItem.IDArtSta)?.sku}
                                <img src={global.baseUrlImage + products.find((p) => p.id == cartItem.IDArtSta)?.image[0]} style={{ width: "50px", height: "50px", objectFit: "contain" }} />

                              </span>
                            )}
                            {global.aziendaID === 3 && cartItem.IDArtSta > 0 && (
                              <span>
                              </span>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </td>

                      {(isBetaRicambi ? clienteVisualizzaPrezzi : true) && (
                        <td className="product-price-cart">
                          {discountedPrice !== null ? (
                            <Fragment>
                              {/*<span className="amount old">
                                        {currency.currencySymbol +
                                          finalProductPrice}
                                        </span>*/}
                              <span className="amount">
                                {currency.currencySymbol + finalProductPrice}
                              </span>
                            </Fragment>
                          ) : (
                            <span className="amount">
                              {currency.currencySymbol + finalProductPrice}
                            </span>
                          )}
                        </td>
                      )}

                      <td className="product-quantity">
                        <div className="cart-plus-minus">
                          {global.aziendaID != 3 && (
                            <button
                              className="dec qtybutton"
                              onClick={() => decrementQty(cartItem, addToast)}
                            >
                              -
                            </button>
                          )}
                          <input
                            className="cart-plus-minus-box"
                            type="text"
                            value={cartItem.quantity}
                            readOnly
                          />
                          {global.aziendaID != 3 && (<button
                            className="inc qtybutton"
                            onClick={() =>
                              addToCart(cartItem, addToast, quantityCount)
                            }
                            disabled={
                              cartItem !== undefined &&
                              cartItem.quantity &&
                              cartItem.quantity >=
                              cartItemStock(
                                cartItem,
                                cartItem.selectedProductColor,
                                cartItem.selectedProductSize
                              )
                            }
                          >
                            +
                          </button>)}
                        </div>
                      </td>
                      {(isBetaRicambi ? clienteVisualizzaPrezzi : true) && (
                        <td className="product-subtotal">
                          {
                            /*discountedPrice !== null
                                    ? currency.currencySymbol +
                                      (
                                        finalDiscountedPrice * cartItem.quantity
                                      ).toFixed(2)
                                    :*/ currency.currencySymbol +
                            (finalProductPrice * cartItem.quantity).toFixed(2)
                          }
                        </td>
                      )}

                      <td className="product-remove">
                        <button
                          onClick={() => removeFromCart(cartItem, addToast)}
                        >
                          <i className="fa fa-times"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  const getCartItemsMobile = () => {
    return (
      <div className="row">
        <div className="col-12">
          <div className="table-content table-responsive cart-table-content">
            <table>
              <tbody>
                {cartItems.map((cartItem, key) => {
                  const discountedPrice = getDiscountPrice(
                    cartItem.price,
                    cartItem.discount,
                    cartItem.pricesco,
                    cartItem
                  );

                  const finalProductPrice = getFinalPriceVariation(
                    cartItem,
                    cartItem.selectedProductColor,
                    cartItem.selectedProductSize
                  ).toFixed(2);
                  const finalDiscountedPrice = (
                    discountedPrice * currency.currencyRate
                  ).toFixed(2);

                  /*discountedPrice != null
                              ? (cartTotalPrice +=
                                  finalDiscountedPrice * cartItem.quantity)
                              :*/ /*(cartTotalPrice +=
finalProductPrice * cartItem.quantity);*/
                  return (
                    <tr key={key}>
                      <td
                        className="product-thumbnail"
                        style={{ padding: "0px", width: "500px" }}
                      >
                        {global.aziendaID == 3 ?
                          <span>
                            <img
                              className="img-fluid"
                              src={global.baseUrlImage + cartItem.image[0]}
                              alt=""
                            />
                          </span> :
                          <Link
                            to={
                              process.env.PUBLIC_URL + "/product/" + cartItem.id
                            }
                          >
                            <img
                              className="img-fluid"
                              src={global.baseUrlImage + cartItem.image[0]}
                              alt=""
                            />
                          </Link>}
                      </td>

                      <td className="product-name" style={{ padding: "0px" }}>
                        {global.aziendaID == 3 ?
                          <span>
                            {cartItem.sku}
                            <br />
                            {cartItem.name}
                          </span> :
                          <Link
                            to={
                              process.env.PUBLIC_URL + "/product/" + cartItem.id
                            }
                          >
                            {cartItem.sku}
                            <br />
                            {cartItem.name}
                          </Link>}
                        {cartItem.selectedProductColor &&
                          cartItem.selectedProductSize ? (
                          <div className="cart-item-variation">
                            <span>Color: {cartItem.selectedProductColor}</span>
                            <span>Size: {cartItem.selectedProductSize}</span>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>

                      <td
                        className="product-price-cart"
                        style={{ padding: "0px", textAlign: "right" }}
                      >
                        <div>
                          {discountedPrice !== null ? (
                            <Fragment>
                              {/*<span className="amount old">
                                        {currency.currencySymbol +
                                          finalProductPrice}
                                        </span>*/}
                              <span className="amount">
                                {currency.currencySymbol + finalProductPrice}
                              </span>
                            </Fragment>
                          ) : (
                            <span className="amount">
                              {currency.currencySymbol + finalProductPrice}
                            </span>
                          )}

                          <div
                            className="cart-plus-minus flex"
                            style={{ justifyContent: "flex-end" }}
                          >
                            {global.aziendaID != 3 && (<button
                              style={{
                                borderRightWidth: "1px",
                                borderRightStyle: "solid",
                                borderRightColor: "#e5e5e5",
                                border: "0px",
                                backgroundColor: "transparent",
                              }}
                              className="dec qtybutton"
                              onClick={() => decrementQty(cartItem, addToast)}
                            >
                              -
                            </button>)}
                            <input
                              className="cart-plus-minus-box"
                              type="text"
                              value={cartItem.quantity}
                              readOnly
                              style={{
                                color: "#333",
                                float: "left",
                                fontSize: "14px",
                                height: "40px",
                                margin: "0px",
                                width: "110px",
                                backgroundColor: "transparent",
                                backgroundAttachment: "scroll",
                                height: "30px",
                                display: "flex",
                                justifyContent: "flex-end",
                                width: "40%",
                                textAlign: "right",
                                color: "black",
                                background: "transparent",
                                borderRWidth: "1px",
                                borderStyle: "solid",

                                borderColor: "#e5e5e5",
                              }}
                            />
                            {global.aziendaID != 3 && (
                              <button
                                style={{
                                  borderRightWidth: "1px",
                                  borderRightStyle: "solid",
                                  borderRightColor: "#e5e5e5",
                                  border: "0px",
                                  backgroundColor: "transparent",
                                }}
                                className="inc qtybutton"
                                onClick={() =>
                                  addToCart(cartItem, addToast, quantityCount)
                                }
                                disabled={
                                  cartItem !== undefined &&
                                  cartItem.quantity &&
                                  cartItem.quantity >=
                                  cartItemStock(
                                    cartItem,
                                    cartItem.selectedProductColor,
                                    cartItem.selectedProductSize
                                  )
                                }
                              >
                                +
                              </button>)}
                          </div>

                          {!!(finalProductPrice * cartItem.quantity) ? (
                            <Fragment>
                              {/*<span className="amount old">
                                        {currency.currencySymbol +
                                          finalProductPrice}
                                        </span>*/}
                              <span className="amount">
                                {(
                                  finalProductPrice * cartItem.quantity
                                ).toFixed(2)}
                              </span>
                            </Fragment>
                          ) : (
                            <span className="amount">
                              {(finalProductPrice * cartItem.quantity).toFixed(
                                2
                              )}
                            </span>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <MetaTags>
        <title>
          {strings.cart} | {informazioni.titleSite}
        </title>
        <meta
          name="description"
          content={strings.cart + " " + strings.siteContent}
        />
      </MetaTags>

      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>Home</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>
        Cart
      </BreadcrumbsItem>

      <LayoutOne>
        {/* breadcrumb */}

        <div className="cart-main-area pt-20 ">
          <div className="container">
            {cartItems && cartItems.length >= 1 ? (
              <Fragment>
                <h3 className="cart-page-title">Articoli nel Carrello</h3>

                <div className="d-none d-lg-block">{getCartItems()}</div>
                <div className="d-block d-lg-none">{getCartItemsMobile()}</div>

                <div className="row">
                  <div className="col-lg-12">
                    <div className="cart-shiping-update-wrapper d-none d-lg-flex">
                      <div className="cart-shiping-update">
                        <Link
                          to={process.env.PUBLIC_URL + "/shop-grid-full-width"}
                        >
                          Continua gli Acquisti
                        </Link>
                      </div>

                      <div className="cart-clear">
                        <button onClick={() => removeAllFromCart(addToast)}>
                          Cancella Lista
                        </button>
                      </div>
                    </div>

                    <div
                      className="cart-shiping-update-wrapper d-flex d-lg-none"
                      style={{ display: "flex" }}
                    >
                      <div
                        className="cart-shiping-update"
                        style={{ width: "50%" }}
                      >
                        <Link
                          style={{ height: "55px", textAlignLast: "center" }}
                          to={process.env.PUBLIC_URL + "/shop-grid-full-width"}
                        >
                          Continua gli Acquisti
                        </Link>
                      </div>

                      <div
                        className="cart-clear"
                        style={{ width: "50%", height: "100%" }}
                      >
                        <button
                          onClick={() => removeAllFromCart(addToast)}
                          style={{ height: "55px" }}
                        >
                          Cancella Lista
                        </button>
                      </div>
                    </div>

                    {/*               <div className="cart-shiping-update-wrapper">
                      <div className="cart-shiping-update">
                        <Link
                          to={process.env.PUBLIC_URL + "/shop-grid-full-width"}
                        >
                          Continua gli Acquisti
                        </Link>
                      </div>
                      <div className="cart-clear">
                        <button onClick={() => removeAllFromCart(addToast)}>
                          Cancella Lista
                        </button>
                      </div>
            </div>*/}
                  </div>
                </div>

                <div className="row">
                  {/*
                  <div className="col-lg-4 col-md-6">
                    <div className="cart-tax">
                      <div className="title-wrap">
                        <h4 className="cart-bottom-title section-bg-gray">
                          Costi di Trasporto e Tasse
                        </h4>
                      </div>
                      <div className="tax-wrapper">
                        <p>
                          Inserisci la Tua Destinazione per Stimare i costi di Trasporto.
                        </p>
                        <div className="tax-select-wrapper">
                          <div className="tax-select">
                            <label>* Paese</label>
                            <select className="email s-email s-wid">
                              <option>Italia</option>
                              <option>Bangladesh</option>
                              <option>Albania</option>
                              <option>Åland Islands</option>
                              <option>Afghanistan</option>
                              <option>Belgium</option>
                            </select>
                          </div>
                          <div className="tax-select">
                            <label>* Regione / Stato</label>
                            <select className="email s-email s-wid">
                              <option>Abruzzo</option>
                              <option>Basilicata</option>
                              <option>Calabria</option>
                              <option>Campania</option>
                              <option>Emilia Romagna</option>
                              <option>Friuli Venezia Giulia</option>
                              <option>Lazio</option>
                              <option>Liguria</option>
                              <option>Lombardia</option>
                              <option>Marche</option>
                              <option>Molise</option>
                              <option>Piemonte</option>
                              <option>Puglia</option>
                              <option>Sardegna</option>
                              <option>Sicilia</option>
                              <option>Toscana</option>
                              <option>Trentino Alto Adige</option>
                              <option>Umbria</option>
                              <option>Valle d'Aosta</option>
                              <option>Veneto</option>
                            </select>
                          </div>
                          <div className="tax-select">
                            <label>* CAP</label>
                            <input type="text" />
                          </div>
                          <button className="cart-btn-2" type="submit">
                            Richedi Quotazione
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>*/}

                  {/*                 <div className="col-lg-4 col-md-6">
                    <div className="discount-code-wrapper" style={{ background: "white", border: "none" }}>
                      <div className="title-wrap">
                        <h4 className="cart-bottom-title section-bg-gray">
                          Usa un Codice Coupon
                        </h4>
                      </div>
                      <div className="discount-code">
                        <p>Inserisci il tuo Coupon.</p>
                        <form>
                          <input type="text" required name="name" />
                          <button className="cart-btn-2" type="submit">
                            Applica Coupon
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>*/}

                  {(isBetaRicambi ? clienteVisualizzaPrezzi : true) && (
                    <h4 className="cart-bottom-title section-bg-gary-cart">
                      Totale Carrello
                    </h4>
                  )}
                  <div className="title-wrap"></div>

                  <div className="col-lg-4 col-md-12">
                    {totPortoFranco > 0 ? (
                      <p
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          backgroundColor: "pink",
                          border: "1px red solid",
                          borderRadius: "10px",
                          padding: "5px",
                          display:
                            global.importoPortoFranco > 0 ? "block" : "none",
                        }}
                      >
                        Aggiungi altri {(390.0 - tot).toFixed(2)} € per la
                        spedizione gratuita
                      </p>
                    ) : (
                      <p
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          backgroundColor: "pink",
                          border: "1px red solid",
                          borderRadius: "10px",
                          padding: "5px",
                          display:
                            global.importoPortoFranco > 0 ? "block" : "none",
                        }}
                      >
                        Complimenti! Hai la spedizione gratuita per questo
                        ordine!
                      </p>
                    )}

                    <div className="grand-totall" style={{ padding: "0px" }}>
                      {(isBetaRicambi ? clienteVisualizzaPrezzi : true) && (
                        <h5>
                          Totale Prodotti{" "}
                          <span>
                            {currency.currencySymbol +
                              cartTotalPrice.toFixed(2)}
                          </span>
                        </h5>
                      )}

                      {(isBetaRicambi ? clienteVisualizzaPrezzi : true) && (
                        <h4 className="grand-totall-title">
                          Gran Totale{" "}
                          <span>
                            {currency.currencySymbol +
                              cartTotalPrice.toFixed(2)}
                          </span>
                        </h4>
                      )}

                      {!inCaricamentoCheckOut && (
                        <Link to={process.env.PUBLIC_URL + "/precheckout"}>
                          Invia Ordine
                        </Link>
                      )}

                      {inCaricamentoCheckOut && (
                        <Article key={"bars"}>
                          <ReactLoading type={"bars"} color="black" />
                          <Prop>{"Bars"}</Prop>
                        </Article>
                      )}

                      {/*
                      <button>
                      <Link to={process.env.PUBLIC_URL + "/checkout"}>
                        Procedi con il checkout
                      </Link>
                      </button>
                       */}
                    </div>
                  </div>
                </div>
              </Fragment>
            ) : (
              <div className="row">
                <div className="col-lg-12">
                  <div className="item-empty-area text-center">
                    <div className="item-empty-area__icon mb-30">
                      <i className="pe-7s-cart"></i>
                    </div>
                    <div className="item-empty-area__text">
                      Il carrello è vuoto
                      <br />{" "}
                      <Link
                        to={process.env.PUBLIC_URL + "/shop-grid-full-width"}
                      >
                        Acquista ora
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

Cart.propTypes = {
  addToCart: PropTypes.func,
  adjustCartForCheckOut: PropTypes.func,
  cartItems: PropTypes.array,
  currency: PropTypes.object,
  decrementQty: PropTypes.func,
  location: PropTypes.object,
  removeAllFromCart: PropTypes.func,
  removeFromCart: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    cartItems: state.cartData,
    currency: state.currencyData,
    userData: state.userData,
    products: state.productData.products,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (item, addToast, quantityCount) => {
      dispatch(addToCart(item, addToast, quantityCount));
    },
    adjustCartForCheckOut: (item) => {
      dispatch(adjustCartForCheckOut(item));
    },
    decrementQty: (item, addToast) => {
      dispatch(decrementQty(item, addToast));
    },
    removeFromCart: (item, addToast) => {
      dispatch(removeFromCart(item, addToast));
    },
    removeAllFromCart: (addToast) => {
      dispatch(removeAllFromCart(addToast));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
